/**
 * @typedef {import('../index').Category} Category
 * @typedef {import('./categoriesThirdOrder').CategoryWithNullableId} CategoryWithNullableId
 */

/**
 * @type {function(Array<Category>): Array<CategoryWithNullableId>}
 */
export const addUncategorisedCategory = (categories) => {
  const uncategorisedExists = categories.find(({ id }) => {
    return id === null
  })
  if (uncategorisedExists) {
    return categories
  } else {
    // Don't check the `uncategorized` id type
    // @ts-ignore
    return [{ name: 'Uncategorized', id: null, position: categories.length }, ...categories]
  }
}
